import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import Shifts from "./Shifts";
import UnassignedShifts from "./UnassignedShifts";
import OpenShifts from "./OpenShifts";
import Pagination from "./Pagination";
import { useScheduleContext } from "../../../../../../hooks/context/useScheduleContext";
import { firstToUpper } from "../../../../../../../../../utils/helpers/string";
import { cn } from "../../../../../../../../../lib/utils";

function Content({ hiddenEvents, page, setPage, perPage, setPerPage, close }: any) {
    const { t } = useTranslation();
    const [menu, setMenu] = useState<string>("shifts");
    const { moreModalTotalItems, type } = useScheduleContext();

    const options = useMemo(() => {
        let values = ["shifts"];
        if (type === "team") {
            values.push("unassigned-shifts");
        }
        if (type === "home") {
            values.push("open-shift");
        }
        return values;
    }, [type]);

    const content = useMemo(() => {
        switch (menu) {
            default:
            case "shifts": {
                return <Shifts close={close} />;
            }
            case "unassigned-shifts": {
                return <UnassignedShifts hiddenEvents={hiddenEvents} close={close} />
            }
            case "open-shift": {
                return <OpenShifts hiddenEvents={hiddenEvents} />
            }
        }
    }, [menu, hiddenEvents, close]);

    return (
        <div className="tw-p-3 tw-h-130 tw-flex tw-flex-col">
            <div className="tw-flex tw-bg-primary/10 tw-p-1 tw-rounded-sm tw-flex-wrap tw-max-w-fit tw-items-center tw-mb-4">
                {options.map((option: string) => (
                    <span
                        key={option}
                        className={cn("tw-py-1 tw-px-3 tw-cursor-pointer tw-text-sm", menu === option && "tw-bg-white tw-rounded-sm")}
                        onClick={() => setMenu(option)}
                    >
                        {firstToUpper(t(option))}
                    </span>
                ))}
            </div>
            <div className="tw-min-h-0 tw-flex-1 tw-max-h-[60vh] tw-overflow-y-auto">
                {content}
            </div>
            {menu === "shifts" && (
                <Pagination
                    page={page}
                    perPage={perPage}
                    setPage={setPage}
                    setPerPage={setPerPage}
                    totalItems={moreModalTotalItems}
                />
            )}
        </div>
    );
}

export default Content;
